<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>邮件邀请</h3>
      </div>

      <div class="main">
        <div class="left">
          <div v-if="!isshow">
            <img :src="posterUrl" style="max-width: 378px">
          </div>
          <!--    邮箱邀请函      -->
          <div style="overflow: hidden; height: 0;width: 0">
            <div id="email" ref="email" class="email">
              <div class="head">
                <img alt="" src="../../../static/headlogo.png">
                <p>北京中国国际展览中心（新馆）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2023年10月26-29日</p>
              </div>
              <div class="content">
                <div class="logo">
                  <img src="../../../static/logo.png">
                  <div style="display: flex;flex-direction: column;justify-content: space-between">
                    <p>{{ companyName }}</p>
                    <p>诚邀您莅临 <br/>
                      第二十届中国国际煤炭采矿技术交流及设备展览会</p>
                  </div>
                </div>

                <p style="margin-top: 50px;font-size: 14px;font-weight: 600;">
                  尊敬的客户：
                </p>

                <p style="font-size: 16px;margin-top: 18px;line-height: 28px;">
                  我司将于10月26-29日在北京参展<span style="color: #006FB8">第二十届中国国际煤炭采矿技术交流及设备展览会</span>。我们将在展会上全面展示新产品、新技术、新解决方案。作为我们的合作伙伴和重要客户，诚邀您莅临我司展位参观、洽谈！
                </p>

                <div class="exhibitor"
                     style="background: #F0F0F0;
                                    height: 303px;
                                    margin-top: 32px;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: space-between;
                                    font-size: 16px">
                  <img src="../../../static/logo.png" style="max-width: 60px;max-height: 60px;margin-top: 10px">
                  <p style="font-weight: 500;">
                    {{ companyName }}
                  </p>
                  <p>
                    <span>展馆：<span style="color: #006FB8">{{ locationl }}</span></span>
                    <span style="margin-left: 25px">展位号：<span style="color: #006FB8">{{ locationl }}</span></span>
                  </p>
                  <p>
                    时间：2023年10月25日-28日
                  </p>
                  <p>
                    地点：北京中国国际展览中心（新馆）
                  </p>
                  <div style="font-size: 16px;
                                      font-family: PingFang SC;
                                      font-weight: 500;
                                      color: #FFFFFF;
                                      line-height: 40px;
                                      width: 200px;
                                      height: 40px;
                                      background: #006FB8;
                                      text-align: center"
                  >立即预约登记参观
                  </div>

                  <p style="display: flex;
                                    justify-content: space-evenly;
                                    margin-bottom: 10px;
                                    width: 100%;
                                    font-size: 18px">
                    <a href="#" style="color: #0071BE">关于我们</a>
                    <a href="#" style="color: #0071BE">我的产品</a>
                    <a href="#" style="color: #0071BE">我的活动</a>
                  </p>
                </div>

                <p style="margin-top: 28px;font-size: 16px;line-height: 28px;">
                  备受行业关注的第二十届中国国际煤炭采矿技术交流及设备展览会将于2023年10月25-28日在北京中国国际展览中心（新馆）举办。本届展会以“智能高效、低碳引领”为主题，吸引了全球13个国家和地区的近800家企业参展，展览面积近11万平方米，创历届展会规模之最。国内外重点煤机装备企业悉数到场参展，本届展会将有众多参展企业携带近两年研发的产品、新装备、新技术参展。智能化主题展品将继续大放异彩，海外品牌参展企业热度持续升温。这必将是我国煤炭行业又一次的饕餮盛宴。本届展会还打造了线上会展——易展煤机网。本届展会预计将吸引全球30多个国家和地区的近12万人次到场参观。
                </p>
                <p style="margin-top: 10px;font-size: 16px;line-height: 28px;">
                  行业盛会！不容错过！期待光临！
                </p>
              </div>

              <div class="navigation"
                   style="display: flex;justify-content: space-between; color: #FFFFFF;font-size: 16px; font-weight: 400; line-height: 30px; text-align: center">
                <div onclick="window.open('#')"
                     style="width: 128px; height: 30px; background: #006FB8; cursor: pointer">
                  展商列表
                </div>
                <div style="width: 128px; height: 30px; background: #006FB8;">
                  展品列表
                </div>
                <div style="width: 128px; height: 30px; background: #006FB8;">
                  展位图
                </div>
                <div style="width: 128px; height: 30px; background: #006FB8;">
                  直播大厅
                </div>
                <div style="width: 128px; height: 30px; background: #006FB8;">
                  了解展会
                </div>
              </div>

              <div class="foot"
                   style="padding: 50px 25px 40px;
                                  font-size: 14px;
                                  background: #FFFFFF;">
                <p style="color: #006FB8; margin-bottom: 19px">
                  参展咨询：
                </p>
                <p style="font-weight: 600; margin-bottom: 30px">
                  中国煤炭工业国际技术咨询有限责任公司
                </p>
                <div style="font-size: 16px">
                  <p style="margin-bottom: 20px">
                    联系人：王子辰
                  </p>
                  <p style="margin-bottom: 20px">
                    电话：010-84293614
                  </p>
                  <p>
                    E-mail：chinaminexpo@vip.163.com
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <!--          <el-button @click="createPoster">test</el-button>-->
          <p class="title">
            请输入观众E-mail地址 <br>
            邀请TA一起参加
          </p>
          <p class="name">
            第二十届中国国际煤炭采矿技术交流及设备展览会
          </p>

          <el-input
              v-model="email"
              :rows="8"
              maxlength="100"
              type="textarea"
              @input=""
          ></el-input>
          <el-button @click="submit">提 交</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";

export default {
  name: "emailInvite",
  data() {
    return {
      posterUrl: '',
      img: '../../../static/logo.png',
      companyName: '中国煤炭工业国际咨询有限责任公司',
      locationl: 'xxx',
      isshow: true, //判断海报是否生成
      email: ''     //文本域
    }
  },
  created() {
    this.$nextTick(function () {
      this.createPoster();
    })
  },
  methods: {
    //生成海报
    createPoster() {
      const vm = this;
      const email = document.getElementById('email');
      html2canvas(email, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        scale: 1, //放大
        x: vm.getActuralPosition(email).left,
        y: vm.getActuralPosition(email).top,
        // onclone(doc) {
        //   let backimg = doc.querySelector('#email')
        //   console.log(backimg)
        //   backimg.style.display='block';
        // }
      }).then(function (canvas) {
        vm.posterUrl = canvas.toDataURL("image/png");
        vm.isshow = false;
      });
    },

    //获取元素绝对位置
    getActuralPosition(element) {
      let acturalLeft = element.offsetLeft;
      let acturalTop = element.offsetTop;
      let curElement = element.offsetParent;
      while (curElement) {
        acturalLeft += curElement.offsetLeft;
        acturalTop += curElement.offsetTop;
        curElement = curElement.offsetParent;
      }
      return {
        left: acturalLeft,
        top: acturalTop,
      }
    },
    //文本域方法
    ctxt () {

    },
    submit () {
      console.log(this.email)
    }
  }
}
</script>

<style lang='scss' scoped>
.body {
  margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #E8E8E8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 114px;
    display: flex;

    .left {
      .email {
        width: 714px;
        //height: 1430px;
        padding: 30px 32px;
        box-sizing: border-box;
        background: #f6f6f7;
        font-family: PingFang SC;
        color: #333333;

        .head {
          background: #006FB8;
          height: 180px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            width: 599px;
            height: 111px;
          }

          p {
            font-size: 16px;
            color: #FEFEFF;
            margin-top: 10px;
          }
        }

        .content {
          padding: 30px 25px 40px;
          background: #FFFFFF;

          .logo {
            display: flex;
            justify-content: space-between;

            p {
              text-align: right;
              font-size: 18px;
              font-weight: 600;
              color: #006FB8;
              line-height: 20px;
            }
          }
        }
      }
    }

    .right {
      margin-top: 196px;
      margin-left: 152px;
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        margin-bottom: 20px;
      }

      .name {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #006FB8;
        line-height: 28px;
        margin-bottom: 58px;
      }
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
}

>>> .el-button {
  background-color: #006FB8;
  color: #FFFFFF;
  width: 102px;
  height: 32px;
  padding: 0;
  font-weight: 400;
  margin-top: 30px;
}
</style>
